import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../cache/CacheKeys'
import CacheManager from '../../cache/CacheManager'
import FinAppHomePageUI from './FinAppHomePageUI.js'

class FinAppHomePageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      bankAccountList: null,
      loanBankBalance: null, // in container
      messageList: null,
      errorList: null,
    }
  }

  render() {
    return (
      <FinAppHomePageUI
        context={this.props.context}
        bankAccountList={this.state.bankAccountList}
        loanBankBalance={this.state.loanBankBalance}
        onRefreshClick={this.onRefreshClick}
        messageList={this.state.messageList}
        errorList={this.state.errorList}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getBankAccounts(context)
    this.getLoanBankBalance(context)
    this.getMessages(context)
  }

  getBankAccounts(context) {
    let cacheManager = new CacheManager({
      resource: `/api/accounts/${context.session.accountId}/bankAccounts`,
      cacheKey: CacheKeys.BankAccounts(context.session.accountId),
      callback: this.getBankAccountsCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getBankAccountsCallback = (response) => {
    this.setState({
      bankAccountList: response.bankAccountList,
      errorList: response.errorList
    })
  }

  getLoanBankBalance(context) {
    let cacheManager = new CacheManager({
      resource: `/api/accounts/${context.session.accountId}/loanBankBalance`,
      cacheKey: CacheKeys.LoanBankBalance(context.session.accountId),
      callback: this.getLoanBankBalanceCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getLoanBankBalanceCallback = (response) => {
    this.setState({
      loanBankBalance: response.loanBankBalance,
      errorList: response.errorList
    })
  }

  onRefreshClick = () => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.BankAccounts(context.session.accountId))
    CacheManager.removeObject(CacheKeys.LoanBankBalance(context.session.accountId))
    this.setState({
      errorList: null,
      loanBankBalance: null,
      bankAccountList: null,
    }, () => {
      this.getLoanBankBalance(context)
      this.getBankAccounts(context)
    })
  }

  getMessages(context) {
    let arr = [
      'c_bank_acc_no',
      'c_ifsc_code',
      'c_current_balance'
    ]
    let keys = arr.join(',')

    let cacheManager = new CacheManager({
      resource: `/api/pub/messages/${keys}/locale/${context.locale}`,
      cacheKey: CacheKeys.Messages('pg_finapp', context.locale),
      callback: this.getMessagesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getMessagesCallback = (response) => {
    this.setState({ messageList: response.messageList })
  }
}

export default withRouter(FinAppHomePageSF)
